module.exports = __webpack_public_path__ + "img/icon-none.bdddc36d.svg";